module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('prb-toolbar', {
    attrs: {
      "disable": !_vm.terms
    }
  }), _vm._v(" "), _c('prb-terms', {
    attrs: {
      "termsDialog": !_vm.terms
    }
  }), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.loading) ? _c('prb-loading') : _vm._e(), _vm._v(" "), (_vm.errorPage) ? _c('v-layout', {
    staticClass: "target__layout text-xs-center",
    staticStyle: {
      "min-height": "70vh"
    },
    attrs: {
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-5 white",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "title white"
  }, [_c('b', [_c('v-icon', {
    staticStyle: {
      "margin-bottom": "3px",
      "margin-right": "3px"
    }
  }, [_vm._v("error_outline")]), _vm._v("\n              Error: Data not found")], 1)])])], 1) : _vm._e(), _vm._v(" "), (_vm.sorted20 && _vm.target && !_vm.loading && !_vm.errorPage) ? _c('v-layout', {
    staticClass: "target__layout"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "target_layout__content elevation-1"
  }, [_c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "target-top__layout__summary-title"
  }, [_vm._v(_vm._s(_vm.titleName))])]), _vm._v(" "), (_vm.portalList.length || _vm.unmapped.length) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-end": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('a', {
    staticClass: "target-top__layout__portal-links",
    attrs: {
      "target": "_blank",
      "href": "http://www.chemicalprobes.org/"
    }
  }, [_c('img', {
    staticClass: "mt-2",
    attrs: {
      "height": "30",
      "src": "http://www.chemicalprobes.org/sites/all/themes/zurb_foundation/images/cp-img/chemical-probes-logo@2x.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col mb-1 mr-2 text-xs-left pa-2"
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": 'http://www.chemicalprobes.org/search/site/' + _vm.titleName,
      "target": "_blank"
    }
  }, [(!_vm.portalList.length && _vm.unmapped.length) ? _c('v-btn', {
    staticClass: "white--text",
    staticStyle: {
      "background": "#455A64"
    }
  }, [_vm._v("\n                       " + _vm._s(_vm.unmapped.length) + " additional probes\n                     ")]) : _vm._e(), _vm._v(" "), (_vm.portalList.length && !_vm.unmapped.length) ? _c('v-btn', {
    staticClass: "white--text",
    staticStyle: {
      "background": "#455A64"
    }
  }, [_vm._v("\n                       " + _vm._s(_vm.portalList.length) + " common probes\n                     ")]) : _vm._e(), _vm._v(" "), (_vm.portalList.length && _vm.unmapped.length) ? _c('v-btn', {
    staticClass: "white--text",
    staticStyle: {
      "background": "#455A64"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.portalList.length) + " common probes, " + _vm._s(_vm.unmapped.length) + " additional probes\n                    ")]) : _vm._e()], 1)])])]) : _vm._e(), _vm._v(" "), _c('prb-target-top', {
    attrs: {
      "target": _vm.target
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "target-probes__layout-title"
  }, [_vm._v("\n                  ASSESSED COMPOUNDS (" + _vm._s(Object.keys(_vm.probes.metadata).length) + ")\n                ")])]), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "teal darken-1",
    attrs: {
      "persistent": "",
      "height": "100%"
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs6": ""
    }
  }, [_c('p', {
    staticClass: "title target-probes__layout__content__setting-btn white--text"
  }, [_vm._v("SETTINGS")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "fab": "",
      "flat": "",
      "light": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }, [_c('v-icon', {
    staticClass: "white--text",
    attrs: {
      "light": ""
    }
  }, [_vm._v("clear")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0 pr-3 pl-4",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": _vm.customFiltersFlag ? 'Disable Custom Weights' : 'Enable Custom Weights',
      "dark": ""
    },
    on: {
      "change": _vm.changeEnableWeights
    },
    model: {
      value: (_vm.customFiltersFlag),
      callback: function($$v) {
        _vm.customFiltersFlag = $$v
      },
      expression: "customFiltersFlag"
    }
  })], 1), _vm._v(" "), (_vm.customFiltersFlag) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "body-2 white--text pl-3"
  }, [_vm._v("CUSTOM VALUES WEIGHTS:")]), _vm._v(" "), _c('div', {
    staticClass: "pl-3 pr-3"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "body-1 white--text"
  }, [_vm._v("SELECTIVITY (0 - " + _vm._s(_vm.filtersCustom.selectivity) + ")")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center white--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs8": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtersCustom.selectivity),
      expression: "filtersCustom.selectivity"
    }],
    staticClass: "range-slider",
    attrs: {
      "step": "0.1",
      "type": "range",
      "min": "0",
      "max": "10"
    },
    domProps: {
      "value": (_vm.filtersCustom.selectivity)
    },
    on: {
      "__r": function($event) {
        _vm.$set(_vm.filtersCustom, "selectivity", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center white--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("10")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "body-1 white--text"
  }, [_vm._v("TARGET POTENCY (0 - " + _vm._s(_vm.filtersCustom.target_potency) + ")")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center white--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs8": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtersCustom.target_potency),
      expression: "filtersCustom.target_potency"
    }],
    staticClass: "range-slider",
    attrs: {
      "step": "0.1",
      "type": "range",
      "min": "0",
      "max": "10"
    },
    domProps: {
      "value": (_vm.filtersCustom.target_potency)
    },
    on: {
      "__r": function($event) {
        _vm.$set(_vm.filtersCustom, "target_potency", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center white--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("10")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "body-1 white--text"
  }, [_vm._v("CELL POTENCY (0 -  " + _vm._s(_vm.filtersCustom.cell_potency) + ")")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center white--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs8": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtersCustom.cell_potency),
      expression: "filtersCustom.cell_potency"
    }],
    staticClass: "range-slider",
    attrs: {
      "step": "0.1",
      "type": "range",
      "min": "0",
      "max": "10"
    },
    domProps: {
      "value": (_vm.filtersCustom.cell_potency)
    },
    on: {
      "__r": function($event) {
        _vm.$set(_vm.filtersCustom, "cell_potency", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center white--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("10")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "body-1 white--text"
  }, [_vm._v("INACTIVE ANALOGS (0 - " + _vm._s(_vm.filtersCustom.inactive_analogs) + ")")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center white--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs8": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtersCustom.inactive_analogs),
      expression: "filtersCustom.inactive_analogs"
    }],
    staticClass: "range-slider",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "step": "0.1",
      "type": "range",
      "min": "0",
      "max": "10"
    },
    domProps: {
      "value": (_vm.filtersCustom.inactive_analogs)
    },
    on: {
      "__r": function($event) {
        _vm.$set(_vm.filtersCustom, "inactive_analogs", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center white--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("10")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "body-1 white--text"
  }, [_vm._v("SAR (0 - " + _vm._s(_vm.filtersCustom.sar) + ")")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center white--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs8": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtersCustom.sar),
      expression: "filtersCustom.sar"
    }],
    staticClass: "range-slider",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "step": "0.1",
      "type": "range",
      "min": "0",
      "max": "10"
    },
    domProps: {
      "value": (_vm.filtersCustom.sar)
    },
    on: {
      "__r": function($event) {
        _vm.$set(_vm.filtersCustom, "sar", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center white--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("10")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "body-1 white--text"
  }, [_vm._v("PAINS (0 - " + _vm._s(_vm.filtersCustom.pains) + ")")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center white--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs8": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtersCustom.pains),
      expression: "filtersCustom.pains"
    }],
    staticClass: "range-slider",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "step": "0.1",
      "type": "range",
      "min": "0",
      "max": "10"
    },
    domProps: {
      "value": (_vm.filtersCustom.pains)
    },
    on: {
      "__r": function($event) {
        _vm.$set(_vm.filtersCustom, "pains", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center white--text",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("10")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "outline": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setDefaultWeights($event)
      }
    }
  }, [_vm._v("SET DEFAULT WEIGHTS")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "outline": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.changeCustom($event)
      }
    }
  }, [_vm._v("APPLY SELECTED WEIGHTS")])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "body-2 white--text pt-3 pl-3"
  }, [_vm._v("SORT BY:")]), _vm._v(" "), _c('div', {
    staticClass: "section group pa-1"
  }, _vm._l((_vm.displayValues), function(v) {
    return _c('div', {
      staticClass: "col",
      style: ({
        background: _vm.sort === v.name ? 'white' : null,
        color: _vm.sort === v.name ? 'black' : null
      }),
      on: {
        "click": function($event) {
          _vm.changeSort(v.name)
        }
      }
    }, [_vm._v(_vm._s(v.title))])
  }))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "body-2 white--text pt-3 pl-3"
  }, [_vm._v("DISPLAY VALUE:")]), _vm._v(" "), _c('div', {
    staticClass: "section group pa-1"
  }, _vm._l((_vm.displayValues), function(v) {
    return _c('div', {
      staticClass: "col",
      style: ({
        background: _vm.display === v.name ? 'white' : null,
        color: _vm.display === v.name ? 'black' : null
      }),
      on: {
        "click": function($event) {
          _vm.changeDisplay(v.name);
        }
      }
    }, [_vm._v(_vm._s(v.title))])
  }))])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pb-1",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-0 ma-1 elevation-1",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "teal lighten-2 elevation-0 pa-2",
    attrs: {
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.sorted20.length) + " HIGHEST RATED")]), _vm._v(" "), _c('v-btn', {
    staticClass: "teal darken-1",
    attrs: {
      "fab": "",
      "flat": "",
      "dark": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("settings")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue-grey darken-2",
    nativeOn: {
      "click": function($event) {
        _vm.goToAll()
      }
    }
  }, [_vm._v("DISPLAY ALL")])], 1), _vm._v(" "), (_vm.sorted20 && !_vm.loading) ? _c('prb-target-compounds', {
    attrs: {
      "all": Object.keys(_vm.probes.metadata).length,
      "sorted20": _vm.sorted20,
      "settings": {
        sort: _vm.sort,
        display: _vm.display
      },
      "distribution": _vm.distribution
    }
  }) : _vm._e()], 1)], 1)], 1)])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('prb-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4116554e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrbCompoundSynopsis.vue
// module id = 557
// module chunks = 1